import React, { Fragment, useCallback, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import { FaCheck, FaClock, FaTimes, FaTrash } from "react-icons/fa";

import CreaControlLegal from "../Modals/crear/CreaControlLegal";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

function InfoControlLegal({ idSolicitud }) {
  const cookies = new Cookies();

  const tipoUsuario = Number(cookies.get("tipo_Usuario"));
  const idUsuario = cookies.get("id");

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);

  // Tipo 1: aprueba o rechaza
  const puedeAprobar = tipoUsuario === 1;

  // Tipo 2: crea y elimina
  const puedeGestionar = tipoUsuario === 2;

  // Tipo 1 y 2 ven columna de acciones
  const tieneAcciones = puedeAprobar || puedeGestionar;

  /**
   * Obtener controles legales
   */
  const getData = useCallback(async () => {
    if (!idSolicitud) return;

    setLoading(true);

    try {
      const response = await axios.get(
        `${API_URL}/ObtenerControlLegalSolicitudPorSolicitudId`,
        {
          auth: AUTH,
          params: {
            SolicitudId: idSolicitud,
          },
        },
      );

      setList(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error al obtener controles legales:", error);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [idSolicitud]);

  /**
   * Eliminar control legal
   * Solo usuario tipo 2
   */
  const handleDelete = useCallback(
    async (id) => {
      const confirmar = window.confirm(
        "¿Está seguro de que desea eliminar este registro?",
      );

      if (!confirmar) return;

      try {
        setProcessingId(id);

        await axios.delete(`${API_URL}/eliminarControlLegalSolicitudPorId`, {
          auth: AUTH,
          params: {
            Id: id,
          },
          data: {
            TipoAccion:
              "Eliminación de registro en sistema de control de calidad",
            IdUsuario: idUsuario,
          },
        });

        setList((prev) => prev.filter((item) => item.id !== id));

        alert("Registro eliminado correctamente.");
      } catch (error) {
        console.error("Error al eliminar el control legal:", error);

        alert(
          "No fue posible eliminar el registro. Por favor, intente nuevamente.",
        );
      } finally {
        setProcessingId(null);
      }
    },
    [idUsuario],
  );

  const handleAprobacion = useCallback(async (controlLegalId, aprobacion) => {
    const accion = aprobacion ? "aprobar" : "rechazar";

    const confirmar = window.confirm(
      `¿Está seguro de que desea ${accion} este control legal?`,
    );

    if (!confirmar) return;

    try {
      setProcessingId(controlLegalId);

      await axios.put(
        `${API_URL}/ActualizaEstadoControlLegalSolicitud/${controlLegalId}/${aprobacion}`,
        {},
        {
          auth: AUTH,
        },
      );

      // Actualizar estado local
      setList((prev) =>
        prev.map((item) =>
          item.id === controlLegalId
            ? {
                ...item,
                aprobada: aprobacion,
                aprobacionRevisada: true,
              }
            : item,
        ),
      );

      alert(
        aprobacion
          ? "Control legal aprobado correctamente."
          : "Control legal rechazado correctamente.",
      );
    } catch (error) {
      console.error(`Error al ${accion} el control legal:`, error);

      alert(
        `No fue posible ${accion} el control legal. Por favor, intente nuevamente.`,
      );
    } finally {
      setProcessingId(null);
    }
  }, []);

  /**
   * Cargar información inicialmente
   */
  useEffect(() => {
    getData();
  }, [getData]);

  const renderEstado = (item) => {
    if (item.aprobacionRevisada === false) {
      return (
        <span className="badge badge-warning">
          <FaClock className="mr-1" />
          Pendiente de revisión
        </span>
      );
    }

    if (item.aprobacionRevisada === true && item.aprobada === true) {
      return (
        <span className="badge badge-success">
          <FaCheck className="mr-1" />
          Aprobado
        </span>
      );
    }

    if (item.aprobacionRevisada === true && item.aprobada === false) {
      return (
        <span className="badge badge-danger">
          <FaTimes className="mr-1" />
          Rechazado
        </span>
      );
    }

    return <span className="badge badge-secondary">Estado no definido</span>;
  };

  const renderAccionesAprobacion = (item) => {
    const isProcessing = processingId === item.id;

    return (
      <div className="d-flex justify-content-center">
        <button
          type="button"
          className="btn btn-success btn-sm mr-2"
          title="Aprobar"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, true)}
        >
          <FaCheck className="mr-1" />

          {isProcessing ? "Procesando..." : "Aprobar"}
        </button>

        <button
          type="button"
          className="btn btn-danger btn-sm"
          title="Rechazar"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, false)}
        >
          <FaTimes className="mr-1" />

          {isProcessing ? "Procesando..." : "Rechazar"}
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Aspectos Control Legal
              </h6>
            </div>

            <div className="card-body">
              {/* SOLO TIPO 2 PUEDE CREAR */}
              {puedeGestionar && (
                <div className="mb-4">
                  <CreaControlLegal
                    idSolicitud={idSolicitud}
                    onCreated={getData}
                  />
                </div>
              )}

              <div className="table-responsive">
                <table
                  className="table table-bordered table-hover"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Proceso</th>
                      <th>Archivo</th>
                      <th>Estado</th>

                      {tieneAcciones && <th>Acciones</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan={tieneAcciones ? 5 : 4}
                          className="text-center"
                        >
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only">Cargando...</span>
                          </div>

                          <div className="mt-2">
                            Cargando controles legales...
                          </div>
                        </td>
                      </tr>
                    ) : list.length === 0 ? (
                      <tr>
                        <td
                          colSpan={tieneAcciones ? 5 : 4}
                          className="text-center text-muted"
                        >
                          No existen controles legales registrados.
                        </td>
                      </tr>
                    ) : (
                      list.map((item) => {
                        const isProcessing = processingId === item.id;

                        return (
                          <tr key={item.id}>
                            {/* ID */}
                            <td>{item.id}</td>

                            {/* PROCESO */}
                            <td>{item.proceso || "Sin información"}</td>

                            {/* ARCHIVO */}
                            <td>
                              {item.adjunto && item.urlAdjunto ? (
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() =>
                                    descargarDocumento(item.urlAdjunto)
                                  }
                                >
                                  Descargar
                                </button>
                              ) : (
                                <span className="text-muted">No adjunto</span>
                              )}
                            </td>

                            {/* ESTADO */}
                            <td>{renderEstado(item)}</td>

                            {/* ACCIONES */}
                            {tieneAcciones && (
                              <td className="text-center">
                                {/* TIPO 1:
                                    SIEMPRE APROBAR / RECHAZAR */}
                                {puedeAprobar && renderAccionesAprobacion(item)}

                                {/* TIPO 2:
                                    SOLO ELIMINAR */}
                                {puedeGestionar && (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    title="Eliminar"
                                    disabled={isProcessing}
                                    onClick={() => handleDelete(item.id)}
                                  >
                                    <FaTrash className="mr-1" />

                                    {isProcessing
                                      ? "Eliminando..."
                                      : "Eliminar"}
                                  </button>
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default InfoControlLegal;
